import {
  Box,
  Text,
  Button,
  HStack,
  List,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tooltip,
} from "@chakra-ui/react";
import DetailItem from "components/DetailItem/DetailItem";
import { formatDistanceToNow } from "date-fns";
import capitalize from "lodash/capitalize";
import { useMemo } from "react";
import { useGetP2PListingUserProfileQuery } from "services/p2pApi";
import { secondsToDhms, summarizeTimeNarration } from "util/utils";

export default function UserPopover(props) {
  const { user, label, _popover } = props;

  const { data: listingOwnerProfile /*isLoading: isLoadingOwnerProfile*/ } =
    useGetP2PListingUserProfileQuery(`${user?.username}`, {
      skip: !user?.username,
    });

  const ownerProfile = useMemo(
    () => listingOwnerProfile?.profile,
    [listingOwnerProfile]
  );

  // console.log("Owner Profile", ownerProfile);

  const ownerName = useMemo(
    () =>
      [
        ownerProfile?.userData?.firstName,
        ownerProfile?.userData?.lastName,
      ].join(" "),
    [ownerProfile]
  );

  const ownerPresenceColor = useMemo(() => {
    const map = {
      online: "var(--primary)",
      offline: "var(--secondary)",
    };

    return map[ownerProfile?.presence?.status ?? "online"];
  }, [ownerProfile]);

  const ownerReleaseSpeed = useMemo(() => {
    if (
      !ownerProfile?.releaseSpeed?.timeSum ||
      !ownerProfile?.releaseSpeed?.tradeCounts
    )
      return "N|A";

    return (
      ownerProfile?.releaseSpeed?.timeSum &&
      +ownerProfile?.releaseSpeed?.timeSum > 0 &&
      ownerProfile?.releaseSpeed?.tradeCounts &&
      +ownerProfile?.releaseSpeed?.tradeCounts > 0 &&
      formatDistanceToNow(
        new Date(
          ((ownerProfile?.releaseSpeed?.timeSum ?? 20030034) /
            (ownerProfile?.releaseSpeed?.tradeCounts ?? 20030034)) *
            1000 +
            Date.now()
        ),
        {
          addSuffix: false,
        }
      )
    );
  }, [ownerProfile]);

  return (
    <Popover flip closeOnBlur placement="auto" {..._popover}>
      <PopoverTrigger>
        <Button
          px="0"
          size="xs"
          fontSize=".95em"
          color="#3151AB"
          lineHeight="16px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          _hover={{
            bg: "transparent",
            shadow: "0 0 0 3px var(--focusColor)",
          }}
          _active={{
            bg: "transparent",
            shadow: "0 0 0 3px var(--focusColor)",
          }}
          w="fit-content"
          minW="fit-content"
          bg="transparent"
          disabled={!ownerProfile}
        >
          {label ?? `@${user?.username}`}
        </Button>
      </PopoverTrigger>
      <PopoverContent _focus={{ shadow: "0 0 0 2px var(--focusColor)" }}>
        <PopoverArrow />
        <PopoverCloseButton
          size="sm"
          _focus={{ shadow: "0 0 0 2px var(--focusColor)" }}
        />
        <PopoverHeader>
          <HStack>
            <Tooltip
              hasArrow
              label={capitalize(ownerProfile?.presence?.status)}
              bg="#cfffdf"
              color="var(--primary)"
              placement="right"
            >
              <Box boxSize="10px" bg={ownerPresenceColor} borderRadius="50px" />
            </Tooltip>
            <Text color="#3151AB">{`@${user?.username}`}</Text>
          </HStack>
        </PopoverHeader>
        <PopoverBody>
          <List>
            <DetailItem
              itemTitle="Name"
              value={ownerName}
              bg="transparent"
              // borderColor="transparent"
              px="0"
              py="4px"
              fontSize="sm"
            />
            <ListItem borderBottom="1px solid #EAEAEA4f">
              <HStack justifyContent="space-between">
                <DetailItem
                  itemTitle="Trades"
                  value={ownerProfile?.combinedTrades ?? 0}
                  bg="transparent"
                  borderColor="transparent"
                  px="0"
                  py="4px"
                  fontSize="sm"
                />
                <DetailItem
                  itemTitle="Rate"
                  value={`${Number(
                    ownerProfile?.combinedRating?.average
                  ).toFixed(2)} ⭐`}
                  bg="transparent"
                  borderColor="transparent"
                  px="0"
                  py="4px"
                  fontSize="sm"
                />
              </HStack>
            </ListItem>
            <DetailItem
              itemTitle="Release Speed"
              value={ownerReleaseSpeed}
              // value={secondsToDhms(ownerProfile?.releaseSpeed?.timeSum)}
              bg="transparent"
              borderColor="transparent"
              px="0"
              py="4px"
              fontSize="sm"
            />
            <DetailItem
              itemTitle="Payment Speed"
              // value={ownerReleaseSpeed}
              value={summarizeTimeNarration(
                secondsToDhms(ownerProfile?.paymentSpeed?.timeSum ?? 1)
              )}
              bg="transparent"
              borderColor="transparent"
              px="0"
              py="4px"
              fontSize="sm"
            />
          </List>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
